/**
 * Mobile menu toggle functionality
 */
function toggleMobileMenu() {
  const mobileButton = document.querySelector('.header-mobile-button');
  const mobileOverlay = document.querySelector('.mobile-overlay');
  const burger = document.querySelector('.header-menu-burger');
  const mobileOverlayBg = document.querySelector('.mobile-overlay-bg');
  const header = document.querySelector('header');
  const headerBar = document.querySelector('.header-bar');

  if (!mobileButton || !burger) return;

  const isOpen = mobileButton.getAttribute('aria-expanded') === 'true';

  if (isOpen) {
    // Close menu
    mobileButton.setAttribute('aria-expanded', 'false');
    mobileButton.setAttribute('aria-label', mobileButton.dataset.labelOpen);
    burger.classList.remove('header-menu-burger--active');
    document.body.classList.remove('overflow-hidden');

    if (mobileOverlayBg) {
      mobileOverlayBg.classList.add('opacity-0');
      setTimeout(() => {
        mobileOverlayBg.classList.add('hidden');
      }, 300);
    }

    if (mobileOverlay) {
      mobileOverlay.classList.add('opacity-0');
      setTimeout(() => {
        mobileOverlay.classList.add('hidden');
        mobileOverlay.classList.remove('flex');
      }, 300);
    }

    // Remove bottom-0 AFTER fade-out animation completes
    if (header) {
      setTimeout(() => {
        header.classList.remove('bottom-0');
      }, 300);
    }

    // Re-check scroll position when closing to restore background if needed
    handleHeaderScroll();
  } else {
    // Open menu
    // Set header to full height FIRST before showing anything
    if (header) {
      header.classList.add('bottom-0');
    }

    // Remove scroll background when mobile menu opens
    if (headerBar) {
      headerBar.classList.remove('bg-theme-green');
    }

    mobileButton.setAttribute('aria-expanded', 'true');
    mobileButton.setAttribute('aria-label', mobileButton.dataset.labelClose);
    burger.classList.add('header-menu-burger--active');
    document.body.classList.add('overflow-hidden');

    if (mobileOverlayBg) {
      mobileOverlayBg.classList.remove('hidden');
      setTimeout(() => {
        mobileOverlayBg.classList.remove('opacity-0');
      }, 0);
    }

    if (mobileOverlay) {
      mobileOverlay.classList.remove('hidden');
      mobileOverlay.classList.add('flex');
      setTimeout(() => {
        mobileOverlay.classList.remove('opacity-0');
      }, 0);
    }
  }
}

/**
 * Close mobile menu (extracted for reuse)
 */
function closeMobileMenu() {
  const mobileButton = document.querySelector('.header-mobile-button');
  if (!mobileButton) return;

  const isOpen = mobileButton.getAttribute('aria-expanded') === 'true';
  if (isOpen) {
    toggleMobileMenu();
  }
}

/**
 * Handle clicks on anchor links in mobile menu
 */
function handleMobileMenuLinks() {
  const mobileOverlay = document.querySelector('.mobile-overlay');
  if (!mobileOverlay) return;

  // Find all links within the mobile overlay that have hash anchors
  const anchorLinks = mobileOverlay.querySelectorAll('a[href*="#"]');

  anchorLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');

      // Check if the link has a hash anchor (and it's not just "#")
      if (href && href.includes('#') && href !== '#') {
        // Close the mobile menu
        closeMobileMenu();
      }
    });
  });
}

/**
 * Handle scroll background for header
 */
function handleHeaderScroll() {
  const headerBar = document.querySelector('.header-bar');
  const scrollThreshold = 50;

  if (!headerBar) return;

  if (window.scrollY > scrollThreshold) {
    headerBar.classList.add('bg-theme-green');
  } else {
    headerBar.classList.remove('bg-theme-green');
  }
}

/**
 * Initialize header functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  const mobileButton = document.querySelector('.header-mobile-button');

  if (mobileButton) {
    mobileButton.addEventListener('click', toggleMobileMenu);
  }

  // Initialize mobile menu link handlers
  handleMobileMenuLinks();

  // Add scroll listener for header background
  window.addEventListener('scroll', handleHeaderScroll);

  // Check initial scroll position
  handleHeaderScroll();
});
